<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 初始化游客ID
    if (!localStorage.getItem('visitorId')) {
      var visitorId = 'guest_' + this.generateUUID();
      localStorage.setItem('visitorId', visitorId);
    }
  },
  methods: {
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
*, :after, :before {
    box-sizing: border-box;
}
html,body{
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    /* overflow: hidden; */
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */

}
</style>



// WEBPACK FOOTER //
// src/App.vue